import { GAME_MODE } from '../data/modes.js';

export const CLASSIC_SCORE_RATING_BANDS = [
  {
    id: 'excellent',
    label: 'Excellent',
    maxCost: 60,
    rangeLabel: '$60M or less',
    sentence: 'An excellent least-cost system with strong control of risk and policy exposure.'
  },
  {
    id: 'strong',
    label: 'Strong',
    maxCost: 75,
    rangeLabel: '> $60M to $75M',
    sentence: 'A strong system with costs held comfortably below the typical pressure zone.'
  },
  {
    id: 'competitive',
    label: 'Competitive',
    maxCost: 95,
    rangeLabel: '> $75M to $95M',
    sentence: 'A competitive result that kept the grid viable, but left some cost pressure.'
  },
  {
    id: 'costly',
    label: 'Costly',
    maxCost: 130,
    rangeLabel: '> $95M to $130M',
    sentence: 'A costly system where disruption, emissions, or portfolio shape pushed costs up.'
  },
  {
    id: 'high-cost',
    label: 'High-cost system',
    maxCost: Infinity,
    rangeLabel: 'Over $130M',
    sentence: 'A high-cost system that struggled to absorb stress across the three years.'
  }
];

export const ADVANCED_SCORE_RATING_BANDS = [
  {
    id: 'excellent',
    label: 'Excellent',
    maxCost: 100,
    rangeLabel: '$100M or less',
    sentence: 'An excellent cost outcome, close to the Advanced planning frontier.'
  },
  {
    id: 'strong',
    label: 'Strong',
    maxCost: 115,
    rangeLabel: '> $100M to $115M',
    sentence: 'A strong cost outcome with manageable pressure from risk and policy.'
  },
  {
    id: 'competitive',
    label: 'Competitive',
    maxCost: 145,
    rangeLabel: '> $115M to $145M',
    sentence: 'A competitive cost outcome that remains within the range of competent Advanced strategies.'
  },
  {
    id: 'costly',
    label: 'Costly',
    maxCost: 190,
    rangeLabel: '> $145M to $190M',
    sentence: 'A costly outcome where disruption, emissions, or shortfall left little room in the plan.'
  },
  {
    id: 'high-cost',
    label: 'High-cost system',
    maxCost: Infinity,
    rangeLabel: 'Over $190M',
    sentence: 'A high-cost outcome that struggled to absorb stress across the three years.'
  }
];

export function scoreRatingBandsForMode(mode) {
  return mode === GAME_MODE.ADVANCED_CAPACITY
    ? ADVANCED_SCORE_RATING_BANDS
    : CLASSIC_SCORE_RATING_BANDS;
}

export function classifyFinalScore(totalCost, mode = GAME_MODE.CLASSIC) {
  const bands = scoreRatingBandsForMode(mode);
  if (!Number.isFinite(totalCost)) return bands[bands.length - 1];
  return bands.find((band) => totalCost <= band.maxCost);
}
